import {useEffect, useState, useRef} from 'react'
import ArrowPopup from './ArrowPopup'
import PointPopup from './PointPopup'

const Popups = ({hover}) => {
	const [popup, setPopup] = useState(null)
	const timerRef = useRef(null)

	useEffect(() => {
		// Очистка предыдущего таймера при каждом ховере
		clearTimeout(timerRef.current)

		if (hover?.type === 'point') {
			// Запускаем таймер, чтобы показать popup с задержкой
			timerRef.current = setTimeout(() => {
				setPopup(hover)
			}, 300) // задержка в 500 мс — можно изменить
		} else {
			// Сразу показываем все, кроме point
			setPopup(hover)
		}

		// Очистка таймера по unmount или при следующем hover
		return () => {
			clearTimeout(timerRef.current)
		}
	}, [hover])

	if (!popup?.type) return null

	switch (popup.type) {
		case 'point':
			return <PointPopup data={popup.data}/>
		case 'arrow':
			return <ArrowPopup data={popup.data}/>
		default:
			return null
	}
}

export default Popups